import { ru } from "vuetify/lib/locale";

export default {
  $vuetify: { ...ru },
  ...ru,
  legal_top: {
    title: "Условия и положения",
    text: "Откройте для себя новости, советы и инсайты для будущих жителей нашего уникального проекта устойчивого образа жизни",
  },
  platform: {
    btn_top:{
      btn_cameras: "Веб-камеры",
      btn_btob: "Управление B&B",
      btn_legal: "Юридические обновления",
    },
    title: "Платформа для участников",
    welcome: "Добро пожаловать",
  },
  platform_auth: {
    title: "Платформа участников Borgoolistico",
    suptitle: "Пожалуйста, войдите с вашим личным ID и паролем, чтобы получить доступ к камерам и информации Borgoolistico",
    btn_login: "Войти"
  },
  contact: {
    links: {
      call: "Позвоните нам",
      insta: "Найдите нас в Instagram",
      whatsapp: "Найдите нас в WhatsApp",
    }
  },
};
